import { ComponentType, createContext, useContext } from 'react';

import type { TileNodeProps } from './TileNode';

/**
 * Optional UI injected into the generic diagram tile by a host (e.g. the
 * presentation designer). Keeps presentation-specific components out of the
 * shared `TileNode`: the node just renders whatever slot it's given, defaulting
 * to the plain tile. With no provider in scope (the common case — entity
 * detail, the standalone waterfall editor, etc.) behavior is unchanged.
 */
export interface TileNodeSlots {
  /**
   * Replaces the plain tile (wrapping `TileNodeBase`). Used by every `tile`
   * node render site, so e.g. the presentation's hover/edit treatment covers
   * all entity tiles. Defaults to the plain tile.
   */
  Tile?: ComponentType<TileNodeProps>;
}

const TileNodeSlotsContext = createContext<TileNodeSlots>({});

export const TileNodeSlotsProvider = TileNodeSlotsContext.Provider;

export function useTileNodeSlots(): TileNodeSlots {
  return useContext(TileNodeSlotsContext);
}
